import React, { useEffect } from 'react';
import TravelingPlanSidebar from './TravelingPlanSidebar';

/**
 * MobilePlanDrawer - Right-side sliding drawer for mobile devices
 * Only visible on screens < 1024px
 */
export default function MobilePlanDrawer({
  isOpen,
  onClose,
  plans,
  planByDate,
  onRemoveItem,
  onClearPlan,
  onCreatePlan,
  onUpdatePlan,
  onDeletePlan,
  onShowCreateModal,
  onShowEditModal,
  savedItems,
  onRemoveSaved,
}) {
  // Close drawer on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 z-40 bg-black/50 transition-opacity lg:hidden ${
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div
        className={`fixed right-0 top-0 z-50 h-full w-80 bg-white shadow-2xl transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        role="dialog"
        aria-modal="true"
        aria-label="Traveling plans"
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute left-4 top-4 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-700 shadow-md transition hover:bg-slate-100"
          aria-label="Close drawer"
        >
          {/* X icon */}
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Sidebar content */}
        <div className="h-full overflow-y-auto pt-2">
          <TravelingPlanSidebar
            plans={plans}
            planByDate={planByDate}
            onRemoveItem={onRemoveItem}
            onClearPlan={onClearPlan}
            onCreatePlan={onCreatePlan}
            onUpdatePlan={onUpdatePlan}
            onDeletePlan={onDeletePlan}
            onShowCreateModal={onShowCreateModal}
            onShowEditModal={onShowEditModal}
            savedItems={savedItems}
            onRemoveSaved={onRemoveSaved}
            isCollapsed={false}
            onToggleCollapse={() => {}}
          />
        </div>
      </div>
    </>
  );
}
